import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

class ToggleMenu {
  constructor(element) {
    element.addEventListener("click", this.onClick.bind(this));
    element.addEventListener("close", this.onClose.bind(this));
    window.addEventListener("click", this.windowClick.bind(this));

    this.isOpen = false;
    this.element = element;
    this.target = document.querySelector(`${element.dataset.target}`);
  }

  onClick() {
    this.target.classList.contains("is-open") ? this.close() : this.open();

    var mainnav = document.getElementById('mainnav');
    var isMain = mainnav.contains(event.target);
    var subnavs = document.querySelectorAll('.navigation__subnav');
    
    subnavs.forEach(subnav => {
      if(isMain && subnav.classList.contains("is-open")) {
        subnav.classList.remove("is-open");
      }
    })
  }

  onClose() {
    this.close();
  }

  open() {
    this.isOpen = true;
    console.log(this.element)
    this.target.classList.add("is-open");
    this.element.classList.add("is-open");
    var brandInfoText = document.getElementById('brand-info-text');
    if(typeof(brandInfoText) != 'undefined' && brandInfoText != null) {
      document.getElementById('brand-info-text').style.visibility = "hidden";
    }
    disableBodyScroll(this.target);
  }

  close() {
    this.isOpen = false;
    this.target.classList.remove("is-open");
    this.element.classList.remove("is-open");
    var brandInfoText = document.getElementById('brand-info-text');
    if(typeof(brandInfoText) != 'undefined' && brandInfoText != null) {
        document.getElementById('brand-info-text').style.visibility = "visible";
    }
    enableBodyScroll(this.target);
  }

  windowClick() {
    var ham = document.getElementById('ham');
    var nav = document.getElementById('nav');
    var brands = document.getElementById('brands');
    var subs = document.querySelectorAll('.expanded-content');

    var isClickHam = ham.contains(event.target);
    var isClickNav = nav.contains(event.target);

    if (isClickHam || isClickNav) {  
      return;
    } else {
      this.target.classList.remove("is-open");
      subs.forEach(sub => {
        sub.classList.remove("is-open");
      })
      enableBodyScroll(this.target);
    }
  }
}

export default ToggleMenu;
